import { createContext, useContext } from "react";

/**
 * Magic Link recipient (token_recipient) view mode.
 *
 * Default `false` = the internal, authenticated view. When `true`, the signal
 * detail renders read-only per the §M3 permission rules for a token recipient:
 * no Claim / Assign / Share / Archive action row, no on-demand runs, no asset
 * send, no right-rail outreach actions, and no follow-up control. The signal
 * content and the action-history timeline are shown read-only.
 *
 * The Magic Link token route wraps the detail subtree in this provider in a
 * later phase; Phase D wires the gating so recipient-view evidence can be
 * produced now against the mock adapter.
 */
export const RecipientModeContext = createContext(false);

export function useRecipientMode(): boolean {
  return useContext(RecipientModeContext);
}
